import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-semibold my-0 text-center"
}
const _hoisted_2 = { class: "custom-upload-st2" }
const _hoisted_3 = {
  key: 0,
  src: "/public/icons/icon-photo.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_4 = { class: "s10" }
const _hoisted_5 = { class: "custom-upload-text-sm" }
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}
const _hoisted_7 = { class: "form-field-split active rounded-20 mt-5 my-6" }
const _hoisted_8 = { class: "form-field-floating full lg w-40" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-field-floating lg reactive w-60" }
const _hoisted_11 = {
  key: 1,
  class: "text-red"
}
const _hoisted_12 = {
  key: 2,
  class: "text-red"
}
const _hoisted_13 = { class: "custom-upload-st2" }
const _hoisted_14 = {
  key: 0,
  src: "/public/icons/icon-idcard-recto.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_15 = { class: "s10" }
const _hoisted_16 = { class: "custom-upload-text-sm" }
const _hoisted_17 = {
  key: 3,
  class: "text-red"
}
const _hoisted_18 = { class: "custom-upload-st2" }
const _hoisted_19 = {
  key: 0,
  src: "/public/icons/icon-idcard-verso.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_20 = { class: "s10" }
const _hoisted_21 = { class: "custom-upload-text-sm" }
const _hoisted_22 = {
  key: 4,
  class: "text-red"
}
const _hoisted_23 = {
  key: 5,
  class: "text-red"
}

import { reactive, ref, computed } from 'vue'
import { showAlert } from '@/utils/swal'

interface UserSummary {
  nom: string
  prenom: string
  email: string
  telephone: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingIdentityDocumentsForm',
  props: {
    user: {},
    types_piece_identites: {},
    hideHeader: { type: Boolean }
  },
  emits: ["saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const errorMessage = ref('')
const formData = reactive({
  photo: null as { file: File; name: string; preview: string | ArrayBuffer | null } | null,
  type_piece_identite: '',
  numero_piece_identite: '',
  piece_recto: null as { file: File; name: string; preview: string | ArrayBuffer | null } | null,
  piece_verso: null as { file: File; name: string; preview: string | ArrayBuffer | null } | null
})

const errors = reactive<Record<string, string>>({
  photo: '',
  piece_recto: '',
  piece_verso: '',
  type_piece_identite: '',
  numero_piece_identite: ''
})

const photoPreview = ref<string>('')
const rectoPreview = ref<string>('')
const versoPreview = ref<string>('')

const photoPreviewStyle = computed(() => {
  if (photoPreview.value) {
    return `background: url('${photoPreview.value}'); background-size: cover;`
  }
  return "background: url('/public/images/empty.png'); background-size: cover;"
})

const rectoPreviewStyle = computed(() => {
  if (rectoPreview.value) {
    return `background: url('${rectoPreview.value}'); background-size: cover;`
  }
  return "background: url('/public/images/empty.png'); background-size: cover;"
})

const versoPreviewStyle = computed(() => {
  if (versoPreview.value) {
    return `background: url('${versoPreview.value}'); background-size: cover;`
  }
  return "background: url('/public/images/empty.png'); background-size: cover;"
})

const validateFile = (file: File): boolean => {
  const maxSize = 5 * 1024 * 1024 // 5MB
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf']

  if (!allowedTypes.includes(file.type)) {
    showAlert.error('Format de fichier non supporté. Veuillez utiliser PDF, JPG, PNG ou GIF.')
    return false
  }

  if (file.size > maxSize) {
    showAlert.error('La taille du fichier dépasse 5MB.')
    return false
  }

  return true
}

const createPreview = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    if (file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = (e) => {
        resolve(e.target?.result as string)
      }
      reader.readAsDataURL(file)
    } else {
      resolve('')
    }
  })
}

const handlePhotoUpload = async (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]

  if (file && validateFile(file)) {
    const preview = await createPreview(file)
    formData.photo = {
      file: file,
      name: file.name,
      preview: preview
    }
    photoPreview.value = preview
    errors.photo = ''
  } else {
    target.value = ''
    formData.photo = null
    photoPreview.value = ''
  }
}

const handleRectoUpload = async (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]

  if (file && validateFile(file)) {
    const preview = await createPreview(file)
    formData.piece_recto = {
      file: file,
      name: file.name,
      preview: preview
    }
    rectoPreview.value = preview
    errors.piece_recto = ''
  } else {
    target.value = ''
    formData.piece_recto = null
    rectoPreview.value = ''
  }
}

const handleVersoUpload = async (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]

  if (file && validateFile(file)) {
    const preview = await createPreview(file)
    formData.piece_verso = {
      file: file,
      name: file.name,
      preview: preview
    }
    versoPreview.value = preview
    errors.piece_verso = ''
  } else {
    target.value = ''
    formData.piece_verso = null
    versoPreview.value = ''
  }
}

function validate() {
  let isValid = true
  Object.keys(errors).forEach(key => {
    errors[key] = ''
  })

  if (!formData.photo) {
    errors.photo = 'La photo est requise'
    isValid = false
  }
  if (!formData.piece_recto) {
    errors.piece_recto = 'La pièce recto est requise'
    isValid = false
  }
  if (!formData.piece_verso) {
    errors.piece_verso = 'La pièce verso est requise'
    isValid = false
  }
  if (!formData.type_piece_identite) {
    errors.type_piece_identite = "Le type de pièce d'identité est requis"
    isValid = false
  }
  if (!formData.numero_piece_identite) {
    errors.numero_piece_identite = "Le numéro de pièce d'identité est requis"
    isValid = false
  }

  return isValid
}

function onSubmit() {
  if (!validate()) {
    return
  }
  errorMessage.value = ''
  emit('saved', { ...formData })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!props.hideHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (props.user && props.user.prenom && props.user.nom)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(props.user.prenom) + " " + _toDisplayString(props.user.nom), 1))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-normal text-center mt-3 mb-7" }, "Identifiez-vous", -1))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("label", {
        for: "file-upload-photo",
        class: _normalizeClass(["custom-upload", { active: formData.photo }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            id: "file-upload-photo",
            name: "file-upload-photo",
            type: "file",
            accept: "image/*",
            onChange: handlePhotoUpload
          }, null, 32),
          _createElementVNode("div", {
            class: "s5 custom-upload-img",
            style: _normalizeStyle(photoPreviewStyle.value)
          }, [
            (!photoPreview.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "custom-upload-text" }, "Photo de profil", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(formData.photo ? formData.photo.name : 'Charger la photo'), 1)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s5 right" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-upload.svg",
              class: "custom-upload-icon"
            })
          ], -1))
        ])
      ], 2),
      (errors.photo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errors.photo), 1))
        : _createCommentVNode("", true),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "h-10" }, null, -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "type_piece_identite",
            id: "type_piece_identite",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.type_piece_identite) = $event))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("option", {
              value: "",
              selected: ""
            }, "Type de pièce", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.types_piece_identites, (value, key) => {
              return (_openBlock(), _createElementBlock("option", {
                value: key,
                key: key
              }, _toDisplayString(value), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.type_piece_identite]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "type_piece_identite" }, [
            _createTextVNode("Pièce d'identité "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "numero_piece_identite",
            id: "numero_piece_identite",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.numero_piece_identite) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.numero_piece_identite]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "numero_piece_identite" }, [
            _createTextVNode("N° de pièce d'identité "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (errors.type_piece_identite)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors.type_piece_identite), 1))
        : _createCommentVNode("", true),
      (errors.numero_piece_identite)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errors.numero_piece_identite), 1))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        for: "file-upload-recto",
        class: _normalizeClass(["custom-upload my-5", { active: formData.piece_recto }])
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("input", {
            id: "file-upload-recto",
            name: "file-upload-recto",
            type: "file",
            accept: "image/*,.pdf",
            onChange: handleRectoUpload
          }, null, 32),
          _createElementVNode("div", {
            class: "s5 custom-upload-img",
            style: _normalizeStyle(rectoPreviewStyle.value)
          }, [
            (!rectoPreview.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_14))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce recto", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(formData.piece_recto ? formData.piece_recto.name : 'Charger l\'image'), 1)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "s5 right" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-upload.svg",
              class: "custom-upload-icon"
            })
          ], -1))
        ])
      ], 2),
      (errors.piece_recto)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors.piece_recto), 1))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        for: "file-upload-verso",
        class: _normalizeClass(["custom-upload", { active: formData.piece_verso }])
      }, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("input", {
            id: "file-upload-verso",
            name: "file-upload-verso",
            type: "file",
            accept: "image/*,.pdf",
            onChange: handleVersoUpload
          }, null, 32),
          _createElementVNode("div", {
            class: "s5 custom-upload-img",
            style: _normalizeStyle(versoPreviewStyle.value)
          }, [
            (!versoPreview.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_19))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", _hoisted_20, [
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce verso", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", _hoisted_21, _toDisplayString(formData.piece_verso ? formData.piece_verso.name : 'Charger l\'image'), 1)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "s5 right" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-upload.svg",
              class: "custom-upload-icon"
            })
          ], -1))
        ])
      ], 2),
      (errors.piece_verso)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(errors.piece_verso), 1))
        : _createCommentVNode("", true),
      _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, JPG, PNG, GIF. Taille max: 5MB. ", -1)),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      _cache[20] || (_cache[20] = _createElementVNode("button", {
        type: "submit",
        class: "btn lg w-100 flex-center mt-5"
      }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-valider.svg",
          class: "btn-icon",
          alt: ""
        }),
        _createElementVNode("span", null, "Valider")
      ], -1))
    ], 32)
  ]))
}
}

})